import React from "react";
import LZString from 'lz-string';
import Map from "../Masking/Map";
import NavPageSelector from "../../components/NavPageSelector";
import SignInComponent from "../../components/Sign/SignComponent";
import CoordinatesInput from "../../components/CoordinatesInput";
import { useState } from "react";
import "./styles.css";
import LandDegradationDialog from "./LandDegradationDialog";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { resetStore } from "../../reducers/resetStore";
import {useMediaQuery, useTheme} from "@mui/material";
import Stripe from "../BasePage/Stripe";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import { useTranslation } from "react-i18next";

const Index = () => {
    const dispatch = useDispatch();
    const retrievedCompressed = localStorage.getItem('mapFileContent');
    const mapFile = retrievedCompressed ? LZString.decompress(retrievedCompressed) : null;
    const [open, setOpen] = useState(false);
    const areas = useSelector((state) => state.mapState.areas);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = useTranslation();

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        dispatch(resetStore());
        setOpen(false);
    };

    return (
        <div className="monitoring-container">
            <div className="map-wrapper">

            {!isMobile && <Stripe>
            <NavPageSelector route={"land-degradation"} />
          <div className="stripe-content">
            <LanguageSwitcher stripe={true}/>
            <SignInComponent
              menuIconColor="black"
              backgroundColor="white"
              classN="modalcontainer-base"
              stripe={true}
            />
          </div>
        </Stripe> }
        <Stripe second={true}>
          <CoordinatesInput disableFileUpload={false} />
          <button
            className="submit-compare-buttons"
            onClick={() => {
                if (!areas || !areas[0] || !areas[0].coordinates) {
                    toast.error(
                        "Please select the area first"
                    );
                } else {
                    handleOpen();
                }
            }}
        >
            {t('Map.land_degradation')}
        </button>
        </Stripe>

        {isMobile && <NavPageSelector route={"land-degradation"} /> }
              

        <Map mapFile={mapFile} />

        <div className="submit-compare-buttons-container">
            
            <LandDegradationDialog mainIndex={"all"} open={open} handleClose={handleClose} />
        </div>
        </div>
        </div>
    );
};

export default Index;